import { motion } from "framer-motion";
import { Quote, Star } from "lucide-react";

const TESTIMONIALS = [
{
  id: 1,
  text: "Had loads of work done by these guys over the years including fitting a shop out. Highly recommended and will use again. Well done John & Wayne.",
  author: "Jay Bar",
  project: "Commercial & Residential",
  rating: 5
},
{
  id: 2,
  text: "Highly recommend Wayne. I've had lots of jobs carried out by him, it's always a professional finish.",
  author: "Kristie Rigby",
  project: "Multiple Projects",
  rating: 5
},
{
  id: 3,
  text: "Had a loft conversion and a single storey extension done with these guys haven't got a single complaint, highly recommended!!",
  author: "Joanne Benson",
  project: "Loft Conversion & Extension",
  rating: 5
},
{
  id: 4,
  text: "Good honest hard working builders, highly recommended.",
  author: "John Farrington",
  project: "Building Work",
  rating: 5
},
{
  id: 5,
  text: "So pleased with our new orangery thanks to John, Wayne and Luke. Brilliant workers.",
  author: "Janet Simpson",
  project: "Orangery Installation",
  rating: 5
},
{
  id: 6,
  text: "Fantastic job on our new kitchen and windows. The team were professional, tidy and finished on time. Would definitely use again for future projects.",
  author: "Margaret Davies",
  project: "Kitchen & Windows",
  rating: 5
}];


const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};

const cardVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.4 }
  }
};

export const TestimonialsSection = ({ onGetQuoteClick }) => {
  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="!pt-[50px] !pb-[60px] bg-slate-50 relative overflow-hidden">
      
      {/* Faded Background Image */}
      <div 
        className="absolute inset-0 opacity-[0.04] pointer-events-none"
        style={{
          backgroundImage: 'url(https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=1200&auto=format&fit=crop)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      />

      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="tech-label text-royal mb-4 block">100's SATISFIED CLIENTS</span>
          <h2
            data-testid="testimonials-heading"
            className="font-heading text-4xl md:text-5xl font-semibold tracking-tight text-slate-900 mb-6">

            What Our Customers Say
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto">
            Don't just take our word for it. Here's what our satisfied customers 
            have to say about working with J. Antrobus & Son.
          </p>
        </div>

        {/* Testimonials Grid */}
        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-100px" }}
          className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">

          {TESTIMONIALS.map((testimonial, index) =>
          <motion.div
            key={testimonial.id}
            variants={cardVariants}
            data-testid={`testimonial-card-${testimonial.id}`}
            className={`testimonial-card bg-white p-8 border border-slate-200 relative ${
            index === 0 ? "md:col-span-2 lg:col-span-1" : ""}`
            }>

              {/* Quote Icon */}
              <Quote
              size={32}
              className="text-slate-200 absolute top-6 right-6" />


              {/* Rating */}
              <div className="flex gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) =>
              <Star
                key={i}
                size={16}
                className="fill-royal text-royal" />

              )}
              </div>

              {/* Quote Text */}
              <blockquote className="text-slate-700 leading-relaxed mb-6 relative z-10">
                "{testimonial.text}"
              </blockquote>

              {/* Author Info */}
              <div className="flex items-center gap-4 pt-6 border-t border-slate-100">
                <div className="w-10 h-10 bg-slate-900 flex items-center justify-center text-white font-heading font-semibold text-sm">
                  {testimonial.author.split(' ').map((n) => n[0]).join('')}
                </div>
                <div>
                  <div className="font-heading font-semibold text-slate-900 text-sm">
                    {testimonial.author}
                  </div>
                  <div className="font-mono text-xs text-slate-500 uppercase tracking-wider">
                    {testimonial.project}
                  </div>
                </div>
              </div>
            </motion.div>
          )}
        </motion.div>

        {/* CTA */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.3 }}
          className="text-center mt-12">

          <p className="text-slate-600 mb-4">
            Join hundreds of satisfied customers across Merseyside & Lancashire
          </p>
          <button
            onClick={onGetQuoteClick}
            data-testid="testimonials-cta"
            className="btn-primary px-8 py-4 inline-flex items-center text-sm">

            Start Your Project Today
          </button>
        </motion.div>
      </div>
    </section>);

};